import { buildTask as _buildTask } from "ember-concurrency/-private/async-arrow-runtime";
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _descriptor20, _descriptor21;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }
import { A } from '@ember/array';
import Controller from '@ember/controller';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import { task } from 'ember-concurrency';
import { parseErrorForDisplay } from 'garaje/utils/flash-promise';
import compact from 'lodash/compact';
import uniq from 'lodash/uniq';
import uniqBy from 'lodash/uniqBy';
import { MODELS_PER_PAGE } from 'roomba/components/record-select/table/component';
import { RoomsOrderBy, SortDirection } from 'roomba/graphql/generated/graphql-types';
import { ROOMS_UNASSIGNED_AT_CURRENT_LOCATION_PER_PAGE } from './route';
let RoombaSettingsCalendarsController = (_class = class RoombaSettingsCalendarsController extends Controller {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "flashMessages", _descriptor, this);
    _initializerDefineProperty(this, "graphql", _descriptor2, this);
    _initializerDefineProperty(this, "linkManager", _descriptor3, this);
    _initializerDefineProperty(this, "roombaMetrics", _descriptor4, this);
    _initializerDefineProperty(this, "state", _descriptor5, this);
    _initializerDefineProperty(this, "featureConfig", _descriptor6, this);
    _initializerDefineProperty(this, "rooms", _descriptor7, this);
    _initializerDefineProperty(this, "totalRoomsCount", _descriptor8, this);
    _initializerDefineProperty(this, "buildingsFilter", _descriptor9, this);
    _initializerDefineProperty(this, "floorFilter", _descriptor10, this);
    _initializerDefineProperty(this, "isBillingNoticeDialogOpen", _descriptor11, this);
    _initializerDefineProperty(this, "showUnpairRoomsDialog", _descriptor12, this);
    _initializerDefineProperty(this, "unassignedRoomsCurrentSortDirection", _descriptor13, this);
    _initializerDefineProperty(this, "unassignedRoomsCurrentSortField", _descriptor14, this);
    _initializerDefineProperty(this, "unassignedRoomsPageNumber", _descriptor15, this);
    _initializerDefineProperty(this, "unassignedRoomsTotalCount", _descriptor16, this);
    _initializerDefineProperty(this, "assignedRoomsTotalCount", _descriptor17, this);
    _initializerDefineProperty(this, "assignedRoomsPageNumber", _descriptor18, this);
    _initializerDefineProperty(this, "nextPageOffset", _descriptor19, this);
    _defineProperty(this, "unassignedRoomFields", [{
      displayName: 'Display name',
      name: 'displayName'
    }, {
      displayName: 'Location',
      name: 'location.name'
    }, {
      displayName: 'Building',
      name: 'building.name'
    }, {
      displayName: 'Floor',
      name: 'floor'
    }]);
    _defineProperty(this, "assignedRoomFields", [{
      displayName: 'Display name',
      name: 'displayName'
    }, {
      displayName: 'Building',
      name: 'building.name'
    }, {
      displayName: 'Floor',
      name: 'floor'
    }]);
    _initializerDefineProperty(this, "selectedUnassignedRooms", _descriptor20, this);
    _initializerDefineProperty(this, "selectedAssignedRooms", _descriptor21, this);
    _defineProperty(this, "saveRoomSelectionTask", _buildTask(() => ({
      context: this,
      generator: function* (selectedRooms, locationId = null) {
        try {
          yield this.graphql.linkRoomsWithLocation(selectedRooms.map(room => room.id), locationId);
          this.rooms = [];
          yield this.updateRoomsListWithAssigned();
          this.nextPageOffset = 0;
          yield this.updateRoomsListWithPageOfUnassigned();
          selectedRooms.clear();
        } catch (e) {
          this.flashMessages.showFlash('error', 'Error', parseErrorForDisplay(e));
        }
      }
    }), {
      drop: true
    }, "saveRoomSelectionTask", null));
    _defineProperty(this, "onBuildingSelectTask", _buildTask(() => ({
      context: this,
      generator: function* (buildings) {
        this.buildingsFilter = buildings;
        this.unassignedRoomsPageNumber = 1;
        this.assignedRoomsPageNumber = 1;
        this.nextPageOffset = 0;
        yield this.updateRoomsListWithAssigned();
        yield this.updateRoomsListWithPageOfUnassigned();
      }
    }), {
      restartable: true
    }, "onBuildingSelectTask", null));
    _defineProperty(this, "onFloorSelectTask", _buildTask(() => ({
      context: this,
      generator: function* (floors) {
        this.floorFilter = floors;
        this.unassignedRoomsPageNumber = 1;
        this.assignedRoomsPageNumber = 1;
        yield this.updateRoomsListWithAssigned();
        yield this.updateRoomsListWithPageOfUnassigned();
      }
    }), {
      restartable: true
    }, "onFloorSelectTask", null));
  }
  get locationName() {
    return this.state.currentLocation?.nameWithCompanyName;
  }
  get unlimitedRoomsEnabled() {
    return this.featureConfig.isEnabled('rooms.unlimitedRooms');
  }
  get roomsUnassignedAtCurrentLocation() {
    return this.rooms.filter(room => this.state.currentLocation?.id !== room.location?.id && (this.buildingsFilter.length === 0 || room.building?.name && this.buildingsFilter.includes(room.building.name)) && (this.floorFilter.length === 0 || room.floor && this.floorFilter.includes(room.floor)));
  }
  get roomsAssignedAtCurrentLocation() {
    return this.rooms.filter(room => this.state.currentLocation?.id === room.location?.id && (this.buildingsFilter.length == 0 || room.building?.name && this.buildingsFilter.includes(room.building.name)) && (this.floorFilter.length === 0 || room.floor && this.floorFilter.includes(room.floor)));
  }
  get assignedAtCurrentLocationRoomsCount() {
    return this.roomsAssignedAtCurrentLocation.length;
  }
  get buildings() {
    return uniq(compact(this.rooms.filter(room => {
      return (this.buildingsFilter.length === 0 || room.building?.name && !this.buildingsFilter.includes(room.building.name)) && (this.floorFilter.length === 0 || room.floor && this.floorFilter.includes(room.floor));
    }).map(room => room.building?.name))).sort();
  }
  get floors() {
    return uniq(compact(this.rooms.filter(room => {
      return (this.buildingsFilter.length === 0 || room.building?.name && this.buildingsFilter.includes(room.building.name)) && (this.floorFilter.length === 0 || room.floor && !this.floorFilter.includes(room.floor));
    }).map(room => room.floor))).sort();
  }
  get backLink() {
    return this.linkManager.createUILink({
      route: 'roomba.settings'
    });
  }
  get roomsAssignedToAnyLocation() {
    return this.rooms.filter(room => !!room.location?.id);
  }
  get roomsSubscriptionQuantity() {
    return this.featureConfig.getLimit('rooms.unlimitedRooms') || 0;
  }
  get showBillingBanner() {
    return this.roomsSubscriptionQuantity !== undefined && this.roomsAssignedToAnyLocation.length >= this.roomsSubscriptionQuantity;
  }
  assignLocation() {
    if (!this.roomsSubscriptionQuantity || !this.state.currentLocation) {
      return;
    }
    this.roombaMetrics.trackEvent('calendar_settings_assign_rooms_button_clicked', {
      numberOfRoomsToAssign: this.selectedUnassignedRooms.length,
      locationId: this.state.currentLocation.id
    });
    const newTotalAssignedRooms = new Set([...this.roomsAssignedToAnyLocation, ...this.selectedUnassignedRooms].map(room => room.id)).size;
    if (newTotalAssignedRooms > this.roomsSubscriptionQuantity && !this.unlimitedRoomsEnabled) {
      this.openBillingNoticeDialog();
      return;
    }
    void this.saveRoomSelectionTask.perform(this.selectedUnassignedRooms, this.state.currentLocation.id);
  }
  unassignLocation() {
    this.closeUnpairRoomsDialog();
    this.roombaMetrics.trackEvent('calendar_settings_unassign_rooms_button_clicked', {
      numberOfRoomsToUnassign: this.selectedAssignedRooms.length,
      locationId: this.state.currentLocation?.id
    });
    void this.saveRoomSelectionTask.perform(this.selectedAssignedRooms);
  }
  monitorClick() {
    this.roombaMetrics.trackEvent('calendar_settings_continue_button_clicked');
  }
  openBillingNoticeDialog() {
    this.roombaMetrics.trackEvent('calendar_settings_billing_notice_dialog_shown', {
      locationId: this.state.currentLocation?.id
    });
    this.isBillingNoticeDialogOpen = true;
  }
  closeBillingNoticeDialog() {
    this.isBillingNoticeDialogOpen = false;
  }
  tryUnassignLocation() {
    if (this.countPairedRoomsToUnassign > 0) {
      this.showUnpairRoomsDialog = true;
      return;
    }
    this.unassignLocation();
  }
  openUnpairRoomsDialog() {
    this.showUnpairRoomsDialog = true;
  }
  closeUnpairRoomsDialog() {
    this.showUnpairRoomsDialog = false;
  }
  get countPairedRoomsToUnassign() {
    return this.selectedAssignedRooms.filter(room => !!room.devices.length).length;
  }
  get pairedRoomsText() {
    if (!this.countPairedRoomsToUnassign || !this.selectedAssignedRooms.length) {
      return '';
    }
    let pairedRoomsText = '';
    if (this.countPairedRoomsToUnassign > 1) {
      // multiple selected multiple paired
      pairedRoomsText += `${this.countPairedRoomsToUnassign} meeting rooms from your selection are paired to a device. Unassigning these rooms from this location will unpair the devices and make the rooms unavailable for booking from the tablet or Envoy mobile app.
      You may reassign the rooms to this location at any time if you have sufficient room licenses available.`;
    } else {
      if (this.selectedAssignedRooms.length > 1) {
        // multiple selected, 1 paired
        pairedRoomsText += `1 meeting room from your selection is paired to a device. `;
      } else {
        // 1 selected and paired
        pairedRoomsText += `This meeting room is paired to a device. `;
      }
      pairedRoomsText += `Unassigning this room from this location will unpair the device and make the room unavailable for booking from the tablet or Envoy mobile app.
      You may reassign the room to this location at any time if you have sufficient room licenses available.`;
    }
    return pairedRoomsText;
  }
  async unassignedRoomsPageChanged(unassignedRoomsPageNumber) {
    this.unassignedRoomsPageNumber = unassignedRoomsPageNumber;
    if (MODELS_PER_PAGE * unassignedRoomsPageNumber <= this.roomsUnassignedAtCurrentLocation.length) {
      return;
    }
    this.nextPageOffset += ROOMS_UNASSIGNED_AT_CURRENT_LOCATION_PER_PAGE;
    await this.updateRoomsListWithPageOfUnassigned();
  }
  async unassignedRoomsSortChanged(sortField, sortDirection) {
    if (this.rooms.length === this.totalRoomsCount) {
      return;
    }
    this.rooms = this.roomsAssignedAtCurrentLocation;
    this.unassignedRoomsCurrentSortField = sortField;
    this.unassignedRoomsCurrentSortDirection = sortDirection;
    this.nextPageOffset = 0;
    await this.updateRoomsListWithPageOfUnassigned();
  }
  setAssignedRoomsPageChanged(pageNumber) {
    this.assignedRoomsPageNumber = pageNumber;
  }
  async updateRoomsListWithAssigned() {
    const sort = this.buildRoomsSortOrder();
    const filter = {
      locationId: {
        _eq: this.state.currentLocation?.id || null,
        _neq: null,
        _in: null,
        _is_null: null,
        _nin: null
      },
      displayName: null,
      buildingId: null,
      floorName: {
        _in: this.floorFilter,
        _eq: null,
        _is_null: null,
        _neq: null,
        _nin: null
      },
      buildingName: {
        _in: this.buildingsFilter,
        _eq: null,
        _is_null: null,
        _neq: null,
        _nin: null
      }
    };
    const {
      items: roomsAssignedToCurrentLocation,
      totalCount: assignedRoomsTotalCount
    } = await this.graphql.getRoomsPaginated(filter, sort);
    this.rooms = uniqBy([...this.rooms, ...roomsAssignedToCurrentLocation], 'id');
    this.assignedRoomsTotalCount = assignedRoomsTotalCount;
  }
  async updateRoomsListWithPageOfUnassigned() {
    const sort = this.buildRoomsSortOrder();
    const filter = {
      locationId: {
        _neq: this.state.currentLocation?.id || null,
        _eq: null,
        _in: null,
        _is_null: null,
        _nin: null
      },
      displayName: null,
      buildingId: null,
      floorName: {
        _in: this.floorFilter,
        _eq: null,
        _is_null: null,
        _neq: null,
        _nin: null
      },
      buildingName: {
        _in: this.buildingsFilter,
        _eq: null,
        _is_null: null,
        _neq: null,
        _nin: null
      }
    };
    const pagination = {
      limit: ROOMS_UNASSIGNED_AT_CURRENT_LOCATION_PER_PAGE,
      offset: this.nextPageOffset
    };
    const {
      items: unassignedRoomsNextPage,
      totalCount: unassignedRoomsTotalCount
    } = await this.graphql.getRoomsPaginated(filter, sort, pagination);
    this.rooms = uniqBy([...this.rooms, ...unassignedRoomsNextPage], 'id');
    this.unassignedRoomsTotalCount = unassignedRoomsTotalCount;
  }
  buildRoomsSortOrder() {
    let sortBy;
    switch (this.unassignedRoomsCurrentSortField) {
      case 'location.name':
        sortBy = RoomsOrderBy.LocationName;
        break;
      case 'building.name':
        sortBy = RoomsOrderBy.BuildingName;
        break;
      case 'floor':
        sortBy = RoomsOrderBy.FloorName;
        break;
      case 'displayName':
      default:
        sortBy = RoomsOrderBy.DisplayName;
        break;
    }
    const sortDirection = this.unassignedRoomsCurrentSortDirection === 'asc' ? SortDirection.Asc : SortDirection.Desc;
    return {
      by: sortBy,
      direction: sortDirection
    };
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "flashMessages", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "graphql", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "linkManager", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "roombaMetrics", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "state", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "featureConfig", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "rooms", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "totalRoomsCount", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 0;
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "buildingsFilter", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "floorFilter", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "isBillingNoticeDialogOpen", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "showUnpairRoomsDialog", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "unassignedRoomsCurrentSortDirection", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 'asc';
  }
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "unassignedRoomsCurrentSortField", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 'displayName';
  }
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "unassignedRoomsPageNumber", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 1;
  }
}), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, "unassignedRoomsTotalCount", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 0;
  }
}), _descriptor17 = _applyDecoratedDescriptor(_class.prototype, "assignedRoomsTotalCount", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 0;
  }
}), _descriptor18 = _applyDecoratedDescriptor(_class.prototype, "assignedRoomsPageNumber", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 1;
  }
}), _descriptor19 = _applyDecoratedDescriptor(_class.prototype, "nextPageOffset", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 0;
  }
}), _descriptor20 = _applyDecoratedDescriptor(_class.prototype, "selectedUnassignedRooms", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return A();
  }
}), _descriptor21 = _applyDecoratedDescriptor(_class.prototype, "selectedAssignedRooms", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return A();
  }
}), _applyDecoratedDescriptor(_class.prototype, "assignLocation", [action], Object.getOwnPropertyDescriptor(_class.prototype, "assignLocation"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "unassignLocation", [action], Object.getOwnPropertyDescriptor(_class.prototype, "unassignLocation"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "monitorClick", [action], Object.getOwnPropertyDescriptor(_class.prototype, "monitorClick"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "openBillingNoticeDialog", [action], Object.getOwnPropertyDescriptor(_class.prototype, "openBillingNoticeDialog"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "closeBillingNoticeDialog", [action], Object.getOwnPropertyDescriptor(_class.prototype, "closeBillingNoticeDialog"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "tryUnassignLocation", [action], Object.getOwnPropertyDescriptor(_class.prototype, "tryUnassignLocation"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "openUnpairRoomsDialog", [action], Object.getOwnPropertyDescriptor(_class.prototype, "openUnpairRoomsDialog"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "closeUnpairRoomsDialog", [action], Object.getOwnPropertyDescriptor(_class.prototype, "closeUnpairRoomsDialog"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "unassignedRoomsPageChanged", [action], Object.getOwnPropertyDescriptor(_class.prototype, "unassignedRoomsPageChanged"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "unassignedRoomsSortChanged", [action], Object.getOwnPropertyDescriptor(_class.prototype, "unassignedRoomsSortChanged"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setAssignedRoomsPageChanged", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setAssignedRoomsPageChanged"), _class.prototype)), _class);
export { RoombaSettingsCalendarsController as default };